export interface ApplicationAccess {
  allowed: boolean;
  reason: 'free' | 'missing_subscription' | 'expired' | 'inactive_assignment' | 'invalid_assignment' | null;
  expires_at: string | null;
  server_time: string;
}

export function remainingAccessMs(access: ApplicationAccess, receivedAt: number, now = Date.now()) {
  if (!access.allowed) return 0;
  const duration = Date.parse(access.expires_at || '') - Date.parse(access.server_time);
  return Number.isFinite(duration) ? Math.max(0, duration - Math.max(0, now - receivedAt)) : 0;
}
